import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusBadgeClass',
})
export class StatusBadgeClassPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'won':
        return 'text-success';
      case 'lost':
        return 'text-danger';
      case 'open':
        return 'text-warning';
      case 'refund':
        return 'text-secondary';
      case 'cancel':
        return 'text-muted';
      default:
        return '';
    }
  }
}
